import type { DataProvider, Identifier } from "ra-core";

export const attachLibraryFile = async (
  dataProvider: DataProvider,
  contactId: Identifier,
  fileId: Identifier,
) => {
  const existing = await dataProvider.getList("contact_files", {
    filter: { contact_id: contactId, file_id: fileId },
    pagination: { page: 1, perPage: 1 },
    sort: { field: "id", order: "ASC" },
  });
  if (existing.total) return;
  await dataProvider.create("contact_files", {
    data: {
      contact_id: contactId,
      file_id: fileId,
      created_at: new Date().toISOString(),
    },
  });
};
